import { HumanTaskBlockFormFieldOptions } from './OptionsField';
import { BlockValueTemplateField } from '../../../../../ConfigFields/CodeMirror/FlowTemplate';
import { HumanTaskIsRequiredBlockFormField } from '../lib/IsRequiredField';
import { type HumanTaskBlockFormFieldsProps } from '../types';

export function HumanTaskOptionValueFormFields(props: HumanTaskBlockFormFieldsProps) {
  const { fieldNamePrefix } = props;
  return (
    <>
      <BlockValueTemplateField label="Field label" fieldName={`${fieldNamePrefix}.label`} />
      <HumanTaskBlockFormFieldOptions fieldNamePrefix={fieldNamePrefix} />
      <BlockValueTemplateField
        label="Variable name"
        fieldName={`${fieldNamePrefix}.variableName`}
      />
      <BlockValueTemplateField label="Inbound data" fieldName={`${fieldNamePrefix}.initialValue`} />
      <HumanTaskIsRequiredBlockFormField fieldNamePrefix={fieldNamePrefix} />
    </>
  );
}
